import { createReducer, on } from '@ngrx/store';
import { SmartApp } from '../../core/models/smart-app.model';
import * as SmartAppActions from './smart-app.actions';

export const smartAppFeatureKey = 'smartApps';

export interface SmartAppState {
  smartApps: SmartApp[];
  error: any;
}

const initialState: SmartAppState = {
  smartApps: [],
  error: null,
};

export const smartAppReducer = createReducer<SmartAppState>(
  initialState,
  on(SmartAppActions.getSmartAppsSuccess, (state, action) => ({
    ...state,
    smartApps: action.smartApps,
    error: null,
  })),
  on(SmartAppActions.getSmartAppsFailure, (state, action) => ({
    ...state,
    error: action.error,
  }))
);
